import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 .977c0-.097 0-.195-.1-.293V.586c0-.097-.1-.195-.2-.293s-.2-.098-.3-.195h-.1c-.1 0-.2 0-.3-.098v.098c-.1 0-.2 0-.3.097L.7 7.039c-.4.097-.7.39-.7.88 0 .39.2.781.6.977l8.6 3.715 3.8 8.407q.3.586.9.587c.4 0 .8-.294.9-.685l7-19.551c.2-.098.2-.196.2-.392q0 .147 0 0m-4.8 2.444-7.4 7.235-6.1-2.64zm-3.3 14.566-2.7-5.963 7.4-7.234z"
    }, null, -1)
  ]))]))
}
export default { render: render }